var MemberProfileEssentials = function(){

    var init = function() {
        $('input[name="format"]').on('click',function(){
            Do.Ajax('/user/report-format',{
                val: $(this).val()
            });
        });
        $('#update-real-names').on('click',function(){
            Do.Ajax('/user/real-names',{
                form:$('#personal-names').serializeJSON()
            });
        });
    };
    
    return {
        init: init,
        repaintRealNames: function(r){
            $('#topbar-avatar').parent().find('span').text(r.fn);
            $('.profile-cover').find('h1').text(r.fn+' '+r.ln);
            $('.sidebar-user').find('.media-body').first('div').text(r.fn+' '+r.ln);
            Do.Notify(r);
        },
    };

}();